module.exports = __webpack_public_path__ + "img/rank_1.ea5e0976.png";